import { MediaModalBoundary } from '../../MediaModal/MediaModalBoundary.js'
import { UploadQueueProvider } from '../../Providers/index.js'
import { ComposerSubmitParams } from '../types.js'

import { Composer } from './Composer.js'

interface Props {
  onKeyDown?: () => void
  onComposerSubmit: (props: ComposerSubmitParams) => Promise<void>
  disabled?: boolean
}

export const ChatComposerContainer = ({
  onComposerSubmit,
  onKeyDown,
  disabled,
}: Props) => {
  return (
    <MediaModalBoundary>
      <UploadQueueProvider>
        <Composer
          onComposerSubmit={onComposerSubmit}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
      </UploadQueueProvider>
    </MediaModalBoundary>
  )
}
